import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { LoaderComponent } from './loader';

@NgModule({
  declarations: [LoaderComponent],
  imports: [IonicModule],
  exports: [LoaderComponent]
})
export class LoaderComponentModule {}



// WEBPACK FOOTER //
// ./src/components/loader/loader.module.ts